import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class NotificationServerPlugin extends SmartenitPlugin {
  public sendEmail(emails: [string], subject: string, message: string): void {
    return this.executeMethod(
      this.componentId,
      this.processorName,
      'SendEmail',
      {
        Subject: subject,
        Text: message,
        To: emails
      }
    );
  }

  public getEffectMethod(context?: any): string {
    return 'SendEmail';
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getResponderAttribute(): string | null {
    return null;
  }

  public getResponderMethod(): string {
    return 'SendEmail';
  }

  public getStatus() {
    // void
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    // void

    return this.state;
  }

  public getProcessedValue(
    value: any,
    attribute?: string,
    method?: string
  ): any {
    if (!method) {
      return value;
    }

    const data = {
      Data: {
        Context: {
          type: 'default'
        }
      },
      Subject: value.Subject,
      Text: value.Text,
      To: {
        emails: [],
        users: []
      }
    };

    if (method == 'SendEmail') {
      data.To.emails = value.To.split(',');
    }

    if (method == 'SendPushNotification') {
      data.To.users = value.To;
    }

    return data;
  }
}
